import {Component, h} from "preact";
import {connect} from "redux-zero/preact";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";
import actions from "../../store/actions";
import App from "../../components/app";
import DetailDesktop from "../../components/detail/desktop";
import DetailMobile from "../../components/detail/mobile";
import {productService} from "../../services/product-service";
import {Product, Variant} from "../../models/product";
import {customerService} from "../../services/customer-service";
import {Like} from "../../models/customer";
import Interstitial from "../../components/interstitial";
import {NY_Tracker} from "../../services/tracking-service";

interface Props {
  setLikes(likes: Like[]);

  isInterstitialOpen: boolean;

  productId?: string;
  variantId?: string;
  isMobile: boolean;

  clearAllFilters();

}

const mapToProps = ({isInterstitialOpen}) => ({isInterstitialOpen});

interface State {
  product: Product;
  variant: Variant;
  notAvailable: boolean;
}

export class Detail extends Component<Props, State> {

  async componentDidMount(): Promise<void> {
    window.scrollTo(0, 0);
    this.setState({notAvailable: true});
    await this.loadProduct(this.props.productId, this.props.variantId);
    NY_Tracker.trackPage(this.getGoogleAnalyticsPageViewUrl(), document.title);
    customerService.subscribeForCustomer(async (data) => {
      if (!customerService.isLoggedIn) {
        this.props.setLikes([]);
      }
      if (data) {
        const {userLikes} = await customerService.loadFavouriteProducts(App.countryCode);
        this.props.setLikes(userLikes).then(() => customerService.likeCachedVariant());
      }
    });
  }

  async componentWillReceiveProps(nextProps: Props) {
    if (nextProps.productId != this.props.productId || nextProps.variantId != this.props.variantId) {
      await this.loadProduct(nextProps.productId, nextProps.variantId);
      NY_Tracker.trackPage(this.getGoogleAnalyticsPageViewUrl(), document.title);
    }
  }

  getGoogleAnalyticsPageViewUrl(): string {
    let trackedUrl = window.location.pathname + window.location.hash;
    if (trackedUrl.indexOf('?') > 0) {
      trackedUrl = trackedUrl.substring(0, trackedUrl.indexOf('?'));
    }
    if (trackedUrl.indexOf("/#") > 0) {
      trackedUrl = trackedUrl.replace('/#', '');
    }

    return trackedUrl;
  }

  private async loadProduct(productId: string, variantId: string) {
    let product = await productService.loadProductById(productId, App.countryCode);
    let variant: Variant;

    if (product) {
      for (const pv of product.variants) {
        if (pv.productId === productId && pv.id === variantId) {
          variant = pv;
          break;
        }
      }
      this.setState({product: product, variant: variant});
    }
    this.setState({notAvailable: false});
  }

  render() {
    if (this.state.notAvailable) {
      return null;
    }

    return (
      <div>
        {this.props.isInterstitialOpen ? <Interstitial/> : null}
        {this.props.isMobile && <DetailMobile product={this.state.product} variant={this.state.variant}/>}
        {!this.props.isMobile && <DetailDesktop product={this.state.product} variant={this.state.variant}/>}
      </div>
    )
  }
}

export default connect(mapToProps, actions)(withDeviceIndicator(Detail));
